module.exports = __webpack_public_path__ + "static/img/144.6a4ac8c6.png";